import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";


import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

require('./plugins')
import axios from './plugins/vue-axios'
import interceptor from './plugins/axios_interceptor'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  axios,
  interceptor,
  render: h => h(App)
}).$mount("#app");